import { InjectionToken } from "@angular/core";

export const PreguntaTipoToken = new InjectionToken("PreguntaTipoToken");
